
import Vue from 'vue'
import {NewSecondhandsApiFunc, setAccessToken} from '@/api'
import { Secondhand } from '@/models'

import TheTemplate from '../components/TheNoSidebarTemplate.vue'
import BaseCloseButton from '@/components/BaseCloseButton.vue'
import BaseSelectorForm, { Option as SelectorOption } from '@/components/BaseSelectorForm.vue'
import SecondhandList from './components/SecondhandList.vue'
import Pager from '@/components/BasePager.vue'

export type DataType = {
  secondhands: Array<Secondhand>;
  searchTarget: string;
  totalPage: number;
  currentPage: number;
  searchOptions: Array<SelectorOption>;
}

export default Vue.extend({
  name: 'SecondhandListScreen',

  components: {
    TheTemplate,
    BaseCloseButton,
    BaseSelectorForm,
    SecondhandList,
    Pager
  },

  data(): DataType {
    return {
      secondhands: [],
      searchTarget: 'gateway',
      totalPage: 0,
      currentPage: 0,
      searchOptions: [
        {
          name: 'GW',
          value: 'gateway'
        },
        {
          name: 'Sensor',
          value: 'sensor'
        },
        {
          name: 'Tablet',
          value: 'tablet'
        }
      ]
    }
  },

  computed: {
    isEmpty(): boolean {
      return !this.secondhands?.length
    }
  },

  mounted() {
    this.fetchSecondhands()
  },

  methods: {
    async fetchSecondhands(page?: number): Promise<void> {
      switch (this.searchTarget) {
        case 'gateway': return await this.fetchSecondhandGateways(page)
        case 'sensor': return await this.fetchSecondhandSensors(page)
        case 'tablet': return await this.fetchSecondhandTablets(page)
      }
    },

    async fetchSecondhandGateways(page?: number): Promise<void> {
        setAccessToken(this.$auth.accessToken)
        const { data, err } = await NewSecondhandsApiFunc().adminListSecondhandGateways(page)

      if (err != null) {
        this.$handleApiError(err, () => {
          this.fetchSecondhands(page)
        })
        return
      }

      this.secondhands = data.list
      this.currentPage = data.currentPage
      this.totalPage = data.totalPage
    },

    async fetchSecondhandSensors(page?: number): Promise<void> {
        setAccessToken(this.$auth.accessToken)
        const { data, err } = await NewSecondhandsApiFunc().adminListSecondhandSensors(page)

      if (err != null) {
        this.$handleApiError(err, () => {
          this.fetchSecondhands(page)
        })
        return
      }

      this.secondhands = data.list
      this.currentPage = data.currentPage
      this.totalPage = data.totalPage
    },

    async fetchSecondhandTablets(page?: number): Promise<void> {
        setAccessToken(this.$auth.accessToken)
        const { data, err } = await NewSecondhandsApiFunc().adminListSecondhandTablets(page)

      if (err != null) {
        this.$handleApiError(err, () => {
          this.fetchSecondhands(page)
        })
        return
      }

      this.secondhands = data.list
      this.currentPage = data.currentPage
      this.totalPage = data.totalPage
    },

    changeTarget(): void {
      this.secondhands = []
      this.fetchSecondhands(1)
    },

    changePage(page: number): void {
      this.fetchSecondhands(page)
    }
  }
})
